import { useParams } from 'react-router-dom'

import {
  useVenueReferAFriendButtonVenueContextQuery,
  useVenueReferAFriendButtonViewerIsCustomerQuery,
} from '../../../../../graphql'

export function useVenueReferAFriendData() {
  const { venueSlug } = useParams<{ venueSlug: string }>()
  const { data } = useVenueReferAFriendButtonVenueContextQuery({ variables: { slug: venueSlug } })
  const venue = data?.venueContext.venue
  const referral = venue?.company.referral ?? null
  const companyName = venue?.company.name ?? null

  const { data: customerData } = useVenueReferAFriendButtonViewerIsCustomerQuery({
    variables: { venueId: venue?.id ?? '' },
    skip: !venue?.id,
  })

  const isCustomer = (customerData?.me?.customers.nodes.length ?? 0) > 0

  return { venue, referral, isCustomer, companyName }
}
